export const MY_NITENDO_STORE = 'MY_NITENDO_STORE';
export const TABLET_NAVBAR_GAME = 'TABLET_NAVBAR_GAME';
export const TABLET_NAVBAR_NITENDO_SWITCH = 'TABLET_NAVBAR_NITENDO_SWITCH';
export const TABLET_NAVBAR_PLAY_NITENDO = 'TABLET_NAVBAR_PLAY_NITENDO';
